<template>
  <div>
    <v-container class="py-8" fluid>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <h1 class="text-h5 mb-6 text-primary font-weight-bold">Contact Us</h1>
          <v-alert
            class="my-4"
            v-model="alert"
            border="start"
            close-label="Close Alert"
            :color="alertColor"
            variant="tonal"
            closable
          >
            {{ alertText }}
          </v-alert>
          <v-form @submit.prevent="submitForm" ref="form">
            <v-text-field
              v-model="user.name"
              label="Name"
              :rules="[(v) => !!v || 'Required']"
            ></v-text-field>
            <v-text-field
              class="mt-2"
              v-model="user.email"
              label="Email"
              :rules="[
                (v) => !!v || 'Required',
                (v) => /.+@.+/.test(v) || 'Email must be valid',
              ]"
            ></v-text-field>
            <v-textarea
              class="mt-2"
              v-model="user.message"
              label="Message"
              rows="5"
              :rules="[(v) => !!v || 'Required']"
            ></v-textarea>
            <v-btn @click="submitForm" color="secondary" class="mt-4">Send</v-btn>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { ref } from "vue";

export default {
  data() {
    return {
      form: ref(null),
      alert: false,
      alertText: "",
      alertColor: "red",
      user: {
        name: "",
        email: "",
        message: "",
      },
    };
  },
  methods: {
    async submitForm() {
      const { valid } = await this.$refs.form.validate();
      if (valid) {
        this.alertColor = "green";
        this.alertText = `Message sent successfully`;
        this.alert = true;
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else {
        this.alertColor = "red";
        this.alertText = `Invalid Details`;
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
          this.alertText = "";
        }, 3000);
      }
    },
  },
};
</script>
